import { defineEventHandler as e } from "h3";
//#region src/lib/logger.types.ts
var t = /* @__PURE__ */ function(e) {
	return e.SkyBlue = "\x1B[94m", e.OceanBlue = "\x1B[34m", e.MidnightBlue = "\x1B[38;5;17m", e.SkyBlueBg = "\x1B[104m", e.OceanBlueBg = "\x1B[44m", e.MidnightBlueBg = "\x1B[48;5;17m", e.MintGreen = "\x1B[92m", e.ForestGreen = "\x1B[32m", e.EmeraldGreen = "\x1B[38;5;28m", e.MintGreenBg = "\x1B[102m", e.ForestGreenBg = "\x1B[42m", e.EmeraldGreenBg = "\x1B[48;5;28m", e.LemonYellow = "\x1B[93m", e.SunflowerYellow = "\x1B[33m", e.GoldYellow = "\x1B[38;5;220m", e.LemonYellowBg = "\x1B[103m", e.SunflowerYellowBg = "\x1B[43m", e.GoldYellowBg = "\x1B[48;5;220m", e.RoseRed = "\x1B[91m", e.FireRed = "\x1B[31m", e.BurgundyRed = "\x1B[38;5;88m", e.RoseRedBg = "\x1B[101m", e.FireRedBg = "\x1B[41m", e.BurgundyRedBg = "\x1B[48;5;88m", e.LavenderPurple = "\x1B[95m", e.RoyalPurple = "\x1B[38;5;93m", e.DeepPurple = "\x1B[38;5;54m", e.LavenderPurpleBg = "\x1B[105m", e.RoyalPurpleBg = "\x1B[48;5;93m", e.DeepPurpleBg = "\x1B[48;5;54m", e.PeachOrange = "\x1B[38;5;215m", e.TangerineOrange = "\x1B[38;5;208m", e.AmberOrange = "\x1B[38;5;214m", e.PeachOrangeBg = "\x1B[48;5;215m", e.TangerineOrangeBg = "\x1B[48;5;208m", e.AmberOrangeBg = "\x1B[48;5;214m", e.SilverGray = "\x1B[37m", e.SlateGray = "\x1B[90m", e.CharcoalGray = "\x1B[38;5;238m", e.SilverGrayBg = "\x1B[47m", e.SlateGrayBg = "\x1B[100m", e.CharcoalGrayBg = "\x1B[48;5;238m", e.PureBlack = "\x1B[30m", e.PureWhite = "\x1B[97m", e.PureBlackBg = "\x1B[40m", e.PureWhiteBg = "\x1B[107m", e.Cyan = "\x1B[36m", e.Reset = "\x1B[0m", e.Bold = "\x1B[1m", e.Dim = "\x1B[2m", e.Underline = "\x1B[4m", e.Blink = "\x1B[5m", e.Reverse = "\x1B[7m", e.Hidden = "\x1B[8m", e;
}({}), n = /* @__PURE__ */ function(e) {
	return e[e.trace = 0] = "trace", e[e.debug = 1] = "debug", e[e.info = 2] = "info", e[e.warn = 3] = "warn", e[e.error = 4] = "error", e[e.fatal = 5] = "fatal", e[e.silent = 6] = "silent", e;
}({});
function r(e) {
	return [
		"trace",
		"debug",
		"info",
		"warn",
		"error",
		"fatal",
		"silent"
	].includes(e);
}
//#endregion
//#region src/lib/error-serialization/error-serializer.ts
var i = class e {
	static {
		this.DEFAULT_MAX_DEPTH = 10;
	}
	static {
		this.CIRCULAR_REF_PLACEHOLDER = "[Circular Reference]";
	}
	static {
		this.MAX_DEPTH_PLACEHOLDER = "[Max Depth Reached]";
	}
	static {
		this.UNABLE_TO_SERIALIZE = "[Unable to serialize]";
	}
	static {
		this.serializationCache = /* @__PURE__ */ new Map();
	}
	static {
		this.MAX_CACHE_SIZE = 100;
	}
	static getCacheKey(e, t, n, r) {
		if (!e.stack) return null;
		let i = e.stack.split("\n")[0] || "";
		return `${e.name}:${e.message}:${i}:${t}:${n}:${r}`;
	}
	static addToCache(e, t) {
		if (this.serializationCache.size >= this.MAX_CACHE_SIZE) {
			let e = this.serializationCache.keys().next().value;
			e && this.serializationCache.delete(e);
		}
		this.serializationCache.set(e, t);
	}
	static serialize(t, n = {}) {
		let { includeStack: r = !0, maxDepth: i = e.DEFAULT_MAX_DEPTH, includeNonEnumerable: a = !1 } = n;
		if (t instanceof Error) {
			let e = this.getCacheKey(t, r, i, a);
			if (e) {
				let t = this.serializationCache.get(e);
				if (t) return t;
			}
			let n = this.serializeError(t, r, i, a, /* @__PURE__ */ new WeakSet());
			return e && this.addToCache(e, n), n;
		}
		if (typeof t == "string") return t;
		let o = this.safeStringify(t, i, /* @__PURE__ */ new WeakSet());
		if (typeof o == "string") return o;
		try {
			return JSON.stringify(o, null, 2);
		} catch {
			return String(o);
		}
	}
	static serializeError(e, t, n, r, i = /* @__PURE__ */ new WeakSet()) {
		if (i.has(e)) return {
			message: e.message,
			name: e.name,
			[Symbol.for("circular")]: this.CIRCULAR_REF_PLACEHOLDER
		};
		i.add(e);
		let a = {
			message: e.message,
			name: e.name
		};
		return t && e.stack && (a.stack = e.stack), "cause" in e && e.cause !== void 0 && (e.cause instanceof Error ? a.cause = this.serializeError(e.cause, t, n - 1, r, i) : a.cause = this.safeStringify(e.cause, n - 1, i)), Object.keys(e).forEach((t) => {
			if (!(t in a)) try {
				let r = e;
				a[t] = this.safeStringify(r[t], n - 1, i);
			} catch {
				a[t] = this.UNABLE_TO_SERIALIZE;
			}
		}), r && Object.getOwnPropertyNames(e).forEach((t) => {
			if (!(t in a) && t !== "stack" && t !== "message" && t !== "name") try {
				let r = Object.getOwnPropertyDescriptor(e, t);
				if (r && r.enumerable === !1) {
					let r = e;
					a[t] = this.safeStringify(r[t], n - 1, i);
				}
			} catch {
				a[t] = this.UNABLE_TO_SERIALIZE;
			}
		}), a;
	}
	static safeStringify(e, t, n = /* @__PURE__ */ new WeakSet()) {
		if (t <= 0) return this.MAX_DEPTH_PLACEHOLDER;
		if (typeof e != "object" || !e) return e;
		if (n.has(e)) return this.CIRCULAR_REF_PLACEHOLDER;
		n.add(e);
		try {
			if (Array.isArray(e)) {
				let r = e.map((e) => this.safeStringify(e, t - 1, n));
				return n.delete(e), r;
			}
			let r = {};
			for (let [i, a] of Object.entries(e)) try {
				r[i] = this.safeStringify(a, t - 1, n);
			} catch {
				r[i] = this.UNABLE_TO_SERIALIZE;
			}
			return n.delete(e), r;
		} catch {
			return n.delete(e), this.UNABLE_TO_SERIALIZE;
		}
	}
}, a = {
	highlight: {
		color: t.LemonYellow,
		bold: !0
	},
	accent: { color: t.SkyBlue },
	attention: {
		color: t.RoyalPurple,
		bold: !0
	},
	success: { color: t.ForestGreen },
	warning: { color: t.TangerineOrange },
	error: { color: t.FireRed },
	info: { color: t.OceanBlue },
	debug: { color: t.SlateGray }
}, o = {
	success: "✅",
	warning: "⚠️",
	error: "❌",
	info: "ℹ️",
	debug: "🐞"
}, s = {
	trace: t.SlateGray,
	debug: t.Cyan,
	info: t.ForestGreen,
	warn: t.SunflowerYellow,
	error: t.FireRed,
	fatal: t.FireRed,
	silent: t.Reset
}, c = class {
	resolveStyle(e, t = "test", n) {
		return this.applyStyle(e, t, n);
	}
	static {
		this.INJECTABLE = !0;
	}
	constructor(e = {}) {
		this.styleCache = /* @__PURE__ */ new Map();
		let t = process.env.NODE_ENV === "test" || process.env.VITEST === "true";
		this.useColors = e.useColors === void 0 ? !t : e.useColors, this.globalStyles = {
			...a,
			...e.styles
		}, this.globalIcons = {
			...o,
			...e.icons
		};
	}
	setUseColors(e) {
		this.useColors = e;
	}
	getUseColors() {
		return this.useColors;
	}
	updateStyleConfig(e, t) {
		this.globalStyles = {
			...this.globalStyles,
			...e
		}, this.globalIcons = {
			...this.globalIcons,
			...t
		};
	}
	formatMessage(e, n, r, i, a) {
		let o = i ? `[${r}:${i}]` : `[${r}]`;
		if (this.useColors) {
			let r = this.getColorForLevel(e);
			return a && (r = a), `${r}${o} ${n}${t.Reset}`;
		} else return `${o} ${n}`;
	}
	formatMessageWithMetadata(e, t, n, r, i) {
		let a = t, o = this.getColorForLevel(e);
		if (r?.style) {
			let e = this.applyStyle(r.style, n, i);
			e && (o = e);
		}
		return r?.icon && (a = `${this.resolveIcon(r.icon, n, i)} ${t}`), this.formatMessage(e, a, n, i, o);
	}
	parseMetadataParameter(e, t = []) {
		if (e && typeof e == "object" && !Array.isArray(e) && ("style" in e || "icon" in e)) return {
			metadata: e,
			restData: t
		};
		let n = e === void 0 ? t : [e, ...t];
		if (n.length > 0) {
			let e = n[n.length - 1];
			if (e && typeof e == "object" && !Array.isArray(e) && ("style" in e || "icon" in e)) return {
				metadata: e,
				restData: n.slice(0, -1)
			};
		}
		return {
			metadata: void 0,
			restData: n
		};
	}
	getColorForLevel(e) {
		let r = s[n[e]];
		return e === n.fatal ? `${t.Bold}${r}` : r || t.Reset;
	}
	applyStyle(e, t, n) {
		let r = this.getStyleCacheValue(e);
		if (r !== void 0) return r;
		if (typeof e == "string") {
			let r = this.getSemanticStyleColor(e, t, n);
			return this.setStyleCache(e, r), r;
		}
		if (typeof e == "object" && "color" in e) {
			if (!this.isValidColor(e.color)) {
				this.setStyleCache(e, void 0), this.logWarning("Invalid color provided. Only predefined ColorEnum values are allowed.", t, n);
				return;
			}
			let r = this.constructStyleCode(e);
			return this.setStyleCache(e, r), r;
		}
		this.setStyleCache(e, void 0), this.logWarning("Unknown style configuration provided. Only semantic style names or valid ColorEnum objects are allowed.", t, n);
	}
	isValidColor(e) {
		return Object.values(t).includes(e);
	}
	isValidIcon(e) {
		return this.isEmojiIcon(e);
	}
	getStyleCacheValue(e) {
		return this.styleCache.has(e) ? this.styleCache.get(e) : void 0;
	}
	setStyleCache(e, t) {
		this.styleCache.set(e, t);
	}
	logWarning(e, t, n) {
		let r = n ? `${t}:${n}` : t;
		console.warn(`[${r}] ${e}`);
	}
	constructStyleCode(e) {
		let n = e.color.toString();
		return e.bold && (n += t.Bold), e.underline && (n += t.Underline), n;
	}
	getSemanticStyleColor(e, n, r) {
		if (this.styleCache.has(e)) return this.styleCache.get(e);
		let i = this.globalStyles[e];
		if (i) {
			let n = i.color.toString();
			return i.bold && (n += t.Bold), i.underline && (n += t.Underline), this.styleCache.set(e, n), n;
		}
		let a = r ? `${n}:${r}` : n;
		console.warn(`[${a}] Unknown semantic style: ${e}. Falling back to default.`), this.styleCache.set(e, void 0);
	}
	getStyleCache() {
		return this.styleCache;
	}
	resolveIcon(e, t, n) {
		if (this.isValidIcon(e)) return e;
		let r = [
			"success",
			"warning",
			"error",
			"info",
			"debug"
		], i = r.find((t) => t === e);
		return i && this.globalIcons[i] ? this.globalIcons[i] : (r.includes(e) ? this.logWarning(`Unknown icon: ${e}. Expected a valid emoji or semantic icon name.`, t, n) : this.logWarning(`Invalid icon: ${e}. Expected a valid emoji or semantic icon name.`, t, n), e);
	}
	isEmojiIcon(e) {
		return (/* @__PURE__ */ "✅.⚠️.❌.ℹ️.🐞.⭐️.🚀.🔥.✔️.✖️.❓.🔒.🔓.⏳.🕒.⬆️.⬇️.➡️.⬅️.📁.📄.👤.👥.✏️.➕.➖.🔔.⚡️.🎁.🐛.🌟.❤️.👀.⚙️.🔧.🔨.🔑.🎉.📝.🚨.📅.💡.🔍.🔗.🔖.📌.📎.✉️.📞.🌍.☁️.🌈.🌙.☀️.❄️.✨.🎵.📷.🎥.🎤.🔊.🔋.🗑️.💰.💳.🎂.🏅.🏆.👑.🛸.🛡️.🛑.▶️.⏸️.⏺️.⏪.⏩.🔁.🔀.🎲.🎈.🍪.☕️.🍵.🍺.🍷.🍕.🍔.🍟.🍎.🍌.🍒.🍋.🥕.🌽.🥦.🥚.🧀.🍞.🍰.🍦.🍫.🍿.🥓.🍤.🐟.🦀.🐙.🐋.🐬.🐧.🐸.🐢.🐍.🐉.🦄.🐱.🐶.🐭.🐰.🐻.🐼.🐨.🐯.🦁.🐒.🐘.🐎.🐄.🐖.🐑.🐔.🦆.🦢.🦉.🦅.🦜.🦚.🦩.🦋.🐝.🐜.🐞.🕷️.🦂.🐌.🪱.🐛.🦗.🦟.🪰.🪳.🪲".split(".")).includes(e);
	}
}, l = class extends Error {
	constructor(e) {
		super(e), this.name = "LoggerError";
	}
}, u = class extends Error {
	constructor(e) {
		super(e), this.name = "LoggerContextError";
	}
}, d = {
	enabled: !1,
	windowMs: 5e3,
	flushOnCritical: !0
}, f = [n.error, n.fatal], p = class {
	constructor(e, t, n) {
		this.config = e, this.formatter = t, this.loggerName = n, this.entries = /* @__PURE__ */ new Map();
	}
	addMessage(e, t, n = "") {
		if (!this.config.enabled || this.config.flushOnCritical && f.includes(e)) return !0;
		let r = this.generateFingerprint(t, e, n), i = this.entries.get(r);
		return i ? i.count++ : this.entries.set(r, {
			message: t,
			level: e,
			context: n,
			firstSeen: Date.now(),
			count: 1
		}), this.scheduleFlush(), !1;
	}
	flush() {
		if (this.entries.size !== 0) {
			this.flushTimer &&= (clearTimeout(this.flushTimer), void 0);
			for (let e of this.entries.values()) this.outputMessage(e);
			this.entries.clear();
		}
	}
	destroy() {
		this.flushTimer &&= (clearTimeout(this.flushTimer), void 0), this.entries.clear();
	}
	generateFingerprint(e, t, n) {
		return `${t}:${n}:${e}`;
	}
	scheduleFlush() {
		this.flushTimer ||= setTimeout(() => {
			this.flush();
		}, this.config.windowMs);
	}
	outputMessage(e) {
		let t = e.message;
		e.count > 1 && (t = `${t} (×${e.count})`);
		let r = this.formatter.format({
			level: e.level,
			message: t,
			logger: this.loggerName,
			timestamp: new Date(e.firstSeen),
			context: e.context || void 0
		});
		switch (e.level) {
			case n.trace:
				console.trace(r);
				break;
			case n.debug:
				console.debug(r);
				break;
			case n.info:
				console.info(r);
				break;
			case n.warn:
				console.warn(r);
				break;
			case n.error:
				console.error(r);
				break;
			case n.fatal:
				console.error(r);
				break;
		}
	}
}, m = class {
	constructor(e) {
		this.styleEngine = e;
	}
	format(e) {
		return e.styling ? this.styleEngine.formatMessageWithMetadata(e.level, e.message, e.logger, e.styling, e.context) : this.styleEngine.formatMessage(e.level, e.message, e.logger, e.context);
	}
	isSelfContained() {
		return !1;
	}
}, h = class {
	constructor(e) {
		this.prettyPrint = e?.prettyPrint ?? !1;
	}
	format(e) {
		try {
			let t = {
				timestamp: e.timestamp.toISOString(),
				level: this.getLevelName(e.level),
				logger: e.logger,
				message: e.message
			};
			return e.context && (t.context = e.context), e.correlationId && (t.correlationId = e.correlationId), e.metadata && Object.keys(e.metadata).length > 0 && (t.metadata = e.metadata), e.error && (t.error = i.serialize(e.error)), JSON.stringify(t, null, this.prettyPrint ? 2 : 0);
		} catch (t) {
			return console.error("JsonFormatter: Failed to serialize log entry to JSON.", {
				error: t,
				entry: e
			}), `${e.level} [${e.logger}] ${e.message} (formatting error)`;
		}
	}
	isSelfContained() {
		return !0;
	}
	getLevelName(e) {
		switch (e) {
			case n.trace: return "trace";
			case n.debug: return "debug";
			case n.info: return "info";
			case n.warn: return "warn";
			case n.error: return "error";
			case n.fatal: return "fatal";
			default: return "info";
		}
	}
}, g = class {
	constructor(e) {
		this.formatterFn = e;
	}
	format(e) {
		return this.formatterFn(e);
	}
	isSelfContained() {
		return !0;
	}
}, _ = class {
	static createConsole(e) {
		return new m(new c({ useColors: e?.useColors }));
	}
	static createJson(e) {
		return new h(e);
	}
	static createCustom(e) {
		return new g(e);
	}
}, v = {
	enabled: !0,
	strategy: "mask",
	maxDepth: 10
}, y = [
	/password/i,
	/token/i,
	/secret/i,
	/apikey|api_key|api-key/i,
	/authorization/i,
	/credential/i,
	/private/i
], b = [
	{
		pattern: /\beyJ[A-Za-z0-9_-]{10,}\.[A-Za-z0-9_-]{10,}\.[A-Za-z0-9_-]{10,}(?!\w)/g,
		replacement: "[TOKEN]"
	},
	{
		pattern: /\bBearer\s+[A-Za-z0-9._~+/-]{8,}=*(?!\w)/gi,
		replacement: "Bearer [TOKEN]"
	},
	{
		pattern: /\b(?:sk_live|sk_test|pk_live|pk_test|ghp|gho|github_pat|xox[baprs]|ya29)[_.-][A-Za-z0-9_.-]{10,}(?!\w)/g,
		replacement: "[TOKEN]"
	},
	{
		pattern: /(token|api_?key|secret|auth_?token)\s*[:=]\s*[A-Za-z0-9._~+/-]{10,}=*/gi,
		replacement: "$1: [TOKEN]"
	},
	{
		pattern: /\b(?!(.)\1{10})[A-Za-z0-9+/]{16,}={1,2}(?!\w)/g,
		replacement: "[TOKEN]"
	},
	{
		pattern: /(?<![A-Za-z0-9+/])(?!(.)\1{10})(?=[A-Za-z0-9+/]*[+/])(?=[A-Za-z0-9+/]*(?:\+|[0-9]))[A-Za-z0-9+/]{16,}(?!\w)/g,
		replacement: "[TOKEN]"
	},
	{
		pattern: /\b(?!(.)\1{10})(?=[A-Za-z0-9+/]*[0-9])(?=[A-Za-z0-9+/]*[A-Za-z])[A-Za-z0-9+/]{20,}={0,2}(?!\w)/g,
		replacement: "[TOKEN]"
	},
	{
		pattern: /\b\d{4}[- ]?\d{4}[- ]?\d{4}[- ]?\d{4}\b/g,
		replacement: "[CARD]"
	},
	{
		pattern: /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/g,
		replacement: "[EMAIL]"
	},
	{
		pattern: /\b(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\b/g,
		replacement: "[IP]"
	},
	{
		pattern: /\b\d{3}-\d{2}-\d{4}\b/g,
		replacement: "[SSN]"
	}
];
//#endregion
//#region src/lib/sanitization/sanitizer.ts
function x(e) {
	return e.replace(/\r\n|\r|\n/g, "\\n").replace(/\t/g, "\\t").replace(/[\x00-\x1f\x7f-\x9f]/g, "");
}
function S(e, t) {
	let n = 0;
	for (let t = 0; t < e.length; t++) {
		let r = e.charCodeAt(t);
		n = (n << 5) - n + r, n &= n;
	}
	return Math.abs(n).toString(16).substring(0, t);
}
function C(e, t) {
	switch (t.strategy) {
		case "mask": return e.replace(t.pattern, t.replacement);
		case "remove": return e.replace(t.pattern, "");
		case "hash": return e.replace(t.pattern, (e) => `[HASH:${S(e, t.hashLength)}]`);
		case "custom": return t.customHandler ? e.replace(t.pattern, t.customHandler) : e.replace(t.pattern, t.replacement);
		default: return e.replace(t.pattern, t.replacement);
	}
}
function w(e, t) {
	let n = e;
	for (let e of t) n = C(n, e);
	return n;
}
function T(e) {
	return y.some((t) => t.test(e));
}
function E(e, t, n = 0, r = /* @__PURE__ */ new WeakSet()) {
	if (!t.enabled || n > t.maxDepth || e == null) return e;
	if (typeof e == "string") {
		let n = w(e, t.rules);
		return n = x(n), n;
	}
	if (Array.isArray(e)) return r.has(e) ? "[Circular Reference]" : (r.add(e), e.map((e) => E(e, t, n + 1, r)));
	if (typeof e == "object") {
		if (r.has(e)) return "[Circular Reference]";
		r.add(e);
		let i = {};
		for (let [a, o] of Object.entries(e)) T(a) && typeof o == "string" ? i[a] = "[REDACTED]" : i[a] = E(o, t, n + 1, r);
		return i;
	}
	return e;
}
function D(e, t) {
	return e.map((e) => ({
		pattern: e.pattern,
		strategy: e.strategy ?? t,
		replacement: e.replacement ?? "[REDACTED]",
		hashLength: e.hashLength ?? 8,
		customHandler: e.customHandler
	}));
}
function O(e) {
	let t = e?.enabled ?? v.enabled, n = e?.strategy ?? v.strategy, r = e?.maxDepth ?? v.maxDepth, i;
	return i = e?.rules ? e.rules : [...b, ...e?.customRules ?? []], {
		enabled: t,
		rules: D(i, n),
		maxDepth: r
	};
}
function k(e, t) {
	if (!t.enabled) return e;
	let n = w(e, t.rules);
	return n = x(n), n;
}
//#endregion
//#region ../../node_modules/@analog-tools/inject/index.js
var A = class {
	static {
		this.contexts = /* @__PURE__ */ new Map();
	}
	static {
		this.defaultScope = "default";
	}
	static getRegistry(e = this.defaultScope) {
		this.contexts.has(e) || this.contexts.set(e, new I());
		let t = this.contexts.get(e);
		if (!t) throw Error(`Failed to create registry for scope '${e}'`);
		return t;
	}
	static createScope(e) {
		if (this.contexts.has(e)) throw Error(`Scope '${e}' already exists`);
		let t = new I();
		return this.contexts.set(e, t), t;
	}
	static destroyScope(e) {
		let t = this.contexts.get(e);
		t && (t.destroy(), this.contexts.delete(e));
	}
	static async destroyScopeAsync(e) {
		let t = this.contexts.get(e);
		t && (await t.destroyAsync(), this.contexts.delete(e));
	}
	static async clearAllAsync() {
		let e = [], t = Array.from(this.contexts.entries());
		for (let [n, r] of t) try {
			await r.destroyAsync();
		} catch (t) {
			t instanceof B ? e.push(...t.failures) : t instanceof Error && e.push({
				serviceName: `scope:${n}`,
				error: t
			});
		}
		if (this.contexts.clear(), e.length > 0) throw new B(e);
	}
	static setDefaultScope(e) {
		this.defaultScope = e;
	}
	static getActiveScopes() {
		return Array.from(this.contexts.keys());
	}
	static clearAll() {
		let e = Array.from(this.contexts.values());
		for (let t of e) t.destroy();
		this.contexts.clear();
	}
}, j = Symbol.for("@analog-tools/inject:SERVICE_TOKEN");
function M(e) {
	return Symbol(e || "ServiceToken");
}
var N = class {
	static {
		this.tokens = /* @__PURE__ */ new WeakMap();
	}
	static getToken(e) {
		if (!this.tokens.has(e)) {
			let t = M(e.name);
			this.tokens.set(e, t);
		}
		let t = this.tokens.get(e);
		if (!t) throw Error(`Failed to get token for service ${e.name}`);
		return t;
	}
	static setToken(e, t) {
		this.tokens.set(e, t);
	}
};
function P(e) {
	return (t) => {
		let n = e || N.getToken(t);
		return N.setToken(t, n), t.INJECTABLE = !0, t[j] = n, t;
	};
}
function F() {
	return A.getRegistry();
}
var I = class {
	constructor() {
		this.serviceMap = /* @__PURE__ */ new Map(), this.initializingServices = /* @__PURE__ */ new Set(), this.initializationPromises = /* @__PURE__ */ new Map(), this.serviceNames = /* @__PURE__ */ new Map(), this.initializedServices = /* @__PURE__ */ new Set(), this.destroyed = !1;
	}
	getServiceKey(e) {
		let t = e[j];
		if (!t) throw new z(e.name);
		return this.serviceNames.set(t, e.name), t;
	}
	getServiceName(e) {
		return this.serviceNames.get(e) ?? "Unknown";
	}
	register(e, ...t) {
		let n = this.getServiceKey(e);
		if (this.initializingServices.has(n)) throw new R([e.name]);
		if (!this.serviceMap.has(n) || this.serviceMap.get(n) === void 0) {
			this.initializingServices.add(n);
			try {
				let r = t.length === 0 ? new e() : new e(...t);
				this.serviceMap.set(n, r);
			} finally {
				this.initializingServices.delete(n);
			}
		}
	}
	registerAsUndefined(e) {
		let t = this.getServiceKey(e);
		this.serviceMap.set(t, void 0);
	}
	registerCustomServiceInstance(e, t) {
		let n = this.getServiceKey(e);
		this.serviceNames.set(n, e.name), this.serviceMap.set(n, t);
	}
	getService(e) {
		let t = this.getServiceKey(e);
		return this.serviceMap.has(t) || this.register(e), this.serviceMap.get(t);
	}
	hasService(e) {
		let t = this.getServiceKey(e);
		return this.serviceMap.has(t);
	}
	async ensureAsyncInitialized(e, t) {
		if (this.initializedServices.has(t)) return;
		if (this.initializationPromises.has(t)) {
			let e = this.initializationPromises.get(t);
			if (e) {
				await e;
				return;
			}
		}
		let n = e;
		if (typeof n.initializeAsync != "function") {
			this.initializedServices.add(t);
			let e = Promise.resolve();
			return this.initializationPromises.set(t, e), e;
		}
		let r = n.initializeAsync().then(() => {
			this.initializedServices.add(t);
		}).catch((e) => {
			throw this.initializationPromises.delete(t), e;
		});
		this.initializationPromises.set(t, r), await r;
	}
	async getServiceAsync(e) {
		let t = this.getServiceKey(e);
		this.serviceMap.has(t) || this.register(e);
		let n = this.serviceMap.get(t);
		return n !== void 0 && await this.ensureAsyncInitialized(n, t), n;
	}
	async registerAsync(e, ...t) {
		let n = this.getServiceKey(e);
		(!this.serviceMap.has(n) || this.serviceMap.get(n) === void 0) && this.register(e, ...t);
		let r = this.serviceMap.get(n);
		await this.ensureAsyncInitialized(r, n);
	}
	async destroyAsync() {
		if (this.destroyed) return;
		this.destroyed = !0;
		let e = Array.from(this.initializationPromises.values());
		e.length > 0 && await Promise.allSettled(e);
		let t = [], n = Array.from(this.serviceMap.entries());
		for (let [e, r] of n) {
			if (!this.initializedServices.has(e) || r === void 0) continue;
			let n = r;
			if (typeof n.onDestroy == "function") try {
				await n.onDestroy();
			} catch (n) {
				t.push({
					serviceName: this.getServiceName(e),
					error: n
				});
			}
		}
		if (this.serviceMap.clear(), this.initializingServices.clear(), this.initializationPromises.clear(), this.initializedServices.clear(), this.serviceNames.clear(), t.length > 0) throw new B(t);
	}
	destroy() {
		this.serviceMap.clear(), this.initializingServices.clear(), this.initializationPromises.clear(), this.initializedServices.clear(), this.serviceNames.clear();
	}
}, L = class extends Error {
	constructor(e, t, n) {
		super(e), this.token = t, this.name = "InjectionError", n && (this.cause = n);
	}
}, R = class extends L {
	constructor(e) {
		super(`Circular dependency detected: ${e.join(" -> ")}`), this.name = "CircularDependencyError";
	}
}, z = class extends L {
	constructor(e) {
		super(`Service '${e}' is missing SERVICE_TOKEN. Add @Injectable() decorator to the class. See: packages/inject/docs/migrations/symbol-tokens.md`, e), this.name = "MissingServiceTokenError";
	}
}, B = class extends L {
	constructor(e) {
		let t = e.map((e) => `${e.serviceName}: ${e.error.message}`).join("; ");
		super(`Failed to destroy ${e.length} service(s): ${t}`), this.failures = e, this.name = "AggregateDestructionError";
	}
	getErrors() {
		return this.failures.map((e) => e.error);
	}
	hasFailure(e) {
		return this.failures.some((t) => t.serviceName === e);
	}
};
function V(e, t = {}) {
	let { required: n = !0 } = t;
	try {
		let t = F().getService(e);
		if (t == null) {
			if (n) throw new L(`Service '${e.name}' not found in registry and is required`, e.name);
			return;
		}
		return t;
	} catch (t) {
		throw t instanceof L ? t : new L(`Failed to inject service '${e.name}'`, e.name, t);
	}
}
//#endregion
//#region \0@oxc-project+runtime@0.139.0/helpers/esm/decorateMetadata.js
function H(e, t) {
	if (typeof Reflect == "object" && typeof Reflect.metadata == "function") return Reflect.metadata(e, t);
}
//#endregion
//#region \0@oxc-project+runtime@0.139.0/helpers/esm/decorate.js
function U(e, t, n, r) {
	var i = arguments.length, a = i < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, n) : r, o;
	if (typeof Reflect == "object" && typeof Reflect.decorate == "function") a = Reflect.decorate(e, t, n, r);
	else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
	return i > 3 && a && Object.defineProperty(t, n, a), a;
}
//#endregion
//#region src/lib/logger.service.ts
var W, G = W = class {
	constructor(e = {}, t, r, i) {
		if (this.config = e, this.childLoggers = {}, this.disabledContexts = [], this.activeGroups = [], i) this.parentLogger = i, this.name = i.name, this.context = r, this.logLevel = i.getLogLevel(), this.styleEngine = i.styleEngine, this.formatter = i.formatter, this.correlationId = i.correlationId, this.sanitizer = i.sanitizer;
		else {
			if (typeof e.level == "string" && !Object.keys(n).includes(e.level)) throw new l(`Invalid log level: ${e.level}`);
			if (this.logLevel = this.castLoglevel(e.level || process.env.LOG_LEVEL || "info"), this.name = e.name || "analog-tools", this.correlationId = e.correlationId, this.setDisabledContexts(e.disabledContexts ?? process.env.LOG_DISABLED_CONTEXTS?.split(",") ?? []), this.styleEngine = t || new c({
				useColors: e.useColors,
				styles: {
					...a,
					...e.styles
				},
				icons: {
					...o,
					...e.icons
				}
			}), this.formatter = e.formatter || _.createConsole({ useColors: this.styleEngine.getUseColors() }), e.deduplication?.enabled) {
				let t = {
					enabled: !0,
					windowMs: e.deduplication.windowMs ?? d.windowMs,
					flushOnCritical: e.deduplication.flushOnCritical ?? d.flushOnCritical
				};
				this.deduplicator = new p(t, this.formatter, this.name);
			}
			this.sanitizer = O(e.sanitization);
		}
	}
	resolveMessage(e) {
		if (typeof e == "function") try {
			return e();
		} catch (e) {
			return console.error("Logger: Message evaluation failed:", e), `[Message evaluation failed: ${e}]`;
		}
		return e;
	}
	isContextEnabled() {
		return !this.context || !(this.parentLogger || this).disabledContexts.includes(this.context);
	}
	setDisabledContexts(e) {
		this.disabledContexts = e;
	}
	getLogLevel() {
		return this.logLevel;
	}
	getDisabledContexts() {
		return (this.parentLogger || this).disabledContexts || [];
	}
	setUseColors(e) {
		(this.parentLogger || this).styleEngine.setUseColors(e);
	}
	getUseColors() {
		return (this.parentLogger || this).styleEngine.getUseColors();
	}
	setCorrelationId(e) {
		this.correlationId = e;
	}
	getCorrelationId() {
		return this.correlationId;
	}
	clearCorrelationId() {
		this.correlationId = void 0;
	}
	forContext(e) {
		return this.childLoggers[e] || (this.childLoggers[e] = new W({}, void 0, e, this)), this.childLoggers[e];
	}
	group(e) {
		if (!this.isContextEnabled()) return;
		(this.parentLogger?.activeGroups || this.activeGroups).push(e);
		let t = this.formatter.format({
			level: n.info,
			message: `Group: ${e}`,
			logger: this.name,
			context: this.context,
			timestamp: /* @__PURE__ */ new Date(),
			correlationId: this.getCorrelationId()
		});
		console.group(`${t} ▼`);
	}
	groupEnd(e) {
		if (!this.isContextEnabled()) return;
		let t = this.parentLogger?.activeGroups || this.activeGroups;
		if (e) {
			let n = t.lastIndexOf(e);
			if (n !== -1) {
				let e = t.splice(n);
				for (let t = 0; t < e.length; t++) console.groupEnd(), console.log("");
			}
		} else t.length > 0 && (t.pop(), console.groupEnd(), console.log(""));
	}
	trace(e, t, ...r) {
		this.doLog(n.trace, e, t, ...r);
	}
	debug(e, t, ...r) {
		this.doLog(n.debug, e, t, ...r);
	}
	info(e, t, ...r) {
		this.doLog(n.info, e, t, ...r);
	}
	warn(e, t, ...r) {
		this.doLog(n.warn, e, t, ...r);
	}
	error(e, t, r, ...i) {
		if (!this.isContextEnabled() || this.logLevel > n.error) return;
		let { message: a, serializedError: o, rawError: s, context: c, data: l } = this.parseErrorParameters(e, t, r, i), u = k(a, this.sanitizer), d = c ? E(c, this.sanitizer) : void 0, f = l || [], p, m = f;
		if (f.length > 0) {
			let e = f[f.length - 1];
			e && typeof e == "object" && !Array.isArray(e) && ("style" in e || "icon" in e) && (p = e, m = f.slice(0, -1));
		}
		let h = {
			level: n.error,
			message: u,
			logger: this.name,
			context: this.context,
			timestamp: /* @__PURE__ */ new Date(),
			metadata: d,
			error: s,
			styling: p,
			correlationId: this.getCorrelationId()
		}, g = this.formatter.format(h);
		if (this.formatter.isSelfContained()) console.error(g);
		else {
			let e = [g];
			o && e.push(o), d && e.push(d), console.error(...e, ...m);
		}
	}
	fatal(e, t, r, ...i) {
		if (!this.isContextEnabled() || this.logLevel > n.fatal) return;
		if (typeof e == "string" && t && typeof t == "object" && !Array.isArray(t) && ("style" in t || "icon" in t)) {
			let r = t, i = k(`FATAL: ${e}`, this.sanitizer), a = this.styleEngine.formatMessageWithMetadata(n.fatal, i, this.name, r, this.context);
			console.error(a);
			return;
		}
		let { message: a, serializedError: o, rawError: s, context: c, data: l } = this.parseErrorParameters(e, t, r, i), u = k(a, this.sanitizer), d = c ? E(c, this.sanitizer) : void 0, f = l || [], p, m = f;
		if (f.length > 0) {
			let e = f[f.length - 1];
			e && typeof e == "object" && !Array.isArray(e) && ("style" in e || "icon" in e) && (p = e, m = f.slice(0, -1));
		}
		let h = {
			level: n.fatal,
			message: `FATAL: ${u}`,
			logger: this.name,
			context: this.context,
			timestamp: /* @__PURE__ */ new Date(),
			metadata: d,
			error: s,
			styling: p,
			correlationId: this.getCorrelationId()
		}, g = this.formatter.format(h);
		if (this.formatter.isSelfContained()) console.error(g);
		else {
			let e = [g];
			o && e.push(o), d && e.push(d), console.error(...e, ...m);
		}
	}
	parseErrorParameters(e, t, n, r = []) {
		if (e instanceof Error && t === void 0) return {
			message: e.message,
			serializedError: i.serialize(e),
			rawError: e,
			data: []
		};
		if (typeof e == "string" && t === void 0) return {
			message: e,
			data: []
		};
		if (typeof e == "string" && t instanceof Error && n === void 0) return {
			message: e,
			serializedError: i.serialize(t),
			rawError: t,
			data: []
		};
		if (typeof e == "string" && this.isLogContext(t) && n === void 0) return {
			message: e,
			context: t,
			data: []
		};
		if (typeof e == "string" && t instanceof Error && this.isLogContext(n)) return {
			message: e,
			serializedError: i.serialize(t),
			rawError: t,
			context: n,
			data: r
		};
		let a = typeof e == "string" ? e : "Unknown error", o = t instanceof Error ? t : void 0;
		return {
			message: a,
			serializedError: t ? i.serialize(t) : void 0,
			rawError: o,
			data: n === void 0 ? r : [n, ...r]
		};
	}
	isLogContext(e) {
		return typeof e == "object" && !!e && !Array.isArray(e) && !(e instanceof Error) && !(e instanceof Date) && !(e instanceof RegExp) && typeof e != "function";
	}
	doLog(e, t, r, ...i) {
		if (!this.isContextEnabled() || this.logLevel > e) return;
		let { metadata: a, restData: o } = this.styleEngine.parseMetadataParameter(r, i), s = this.resolveMessage(t);
		if (s = k(s, this.sanitizer), !this.handleDeduplication(e, s, a, o)) return;
		let c = o?.map((e) => E(e, this.sanitizer)), l, u = {};
		c && c.length > 0 && c.forEach((e, t) => {
			e instanceof Error && !l ? l = e : typeof e == "object" && e ? Object.assign(u, e) : u[`arg${t}`] = e;
		});
		let d = {
			level: e,
			message: s,
			logger: this.name,
			context: this.context,
			timestamp: /* @__PURE__ */ new Date(),
			metadata: Object.keys(u).length > 0 ? u : void 0,
			error: l,
			styling: a,
			correlationId: this.getCorrelationId()
		}, f = this.formatter.format(d), p = this.formatter.isSelfContained();
		switch (e) {
			case n.trace:
				p ? console.trace(f) : console.trace(f, ...c || []);
				break;
			case n.debug:
				p ? console.debug(f) : console.debug(f, ...c || []);
				break;
			case n.info:
				p ? console.info(f) : console.info(f, ...c || []);
				break;
			case n.warn:
				p ? console.warn(f) : console.warn(f, ...c || []);
				break;
			case n.error:
			case n.fatal:
				p ? console.error(f) : console.error(f, ...c || []);
				break;
		}
	}
	castLoglevel(e) {
		if (r(e)) switch (e) {
			case "trace": return n.trace;
			case "debug": return n.debug;
			case "info": return n.info;
			case "warn": return n.warn;
			case "error": return n.error;
			case "fatal": return n.fatal;
			case "silent": return n.silent;
		}
		throw r(e.toLowerCase()) ? new l(`Invalid log level: ${e}. Log levels are case-sensitive. Valid levels: trace, debug, info, warn, error, fatal, silent.`) : new l(`Invalid log level: ${e}. Valid levels: trace, debug, info, warn, error, fatal, silent.`);
	}
	shouldLogImmediately(e, t) {
		let n = (this.parentLogger || this).deduplicator;
		if (!n) return !0;
		try {
			return n.addMessage(e, t, this.context);
		} catch (e) {
			return console.error("Logger deduplication error:", e), !0;
		}
	}
	handleDeduplication(e, t, n, r) {
		return !n && r.length === 0 ? this.shouldLogImmediately(e, t) : !0;
	}
};
G = W = U([P(), H("design:paramtypes", [
	Object,
	c === void 0 ? Object : c,
	String,
	G === void 0 ? Object : G
])], G);
//#endregion
//#region src/lib/nitro.ts
function K(t = "api") {
	return e((e) => {
		let n = V(G).forContext(t);
		e.context.logger = n, n.debug("Request received", {
			method: e.method,
			path: e.path,
			requestId: e.context.id
		});
	});
}
function q(t, n = {}) {
	let { namespace: r = "api", level: i = "debug", logResponse: a = !1 } = n;
	return e(async (e) => {
		let n = V(G).forContext(r), o = Date.now();
		try {
			let r = await t(e), s = Date.now() - o, c = {
				trace: "trace",
				debug: "debug",
				info: "info",
				warn: "warn",
				error: "error",
				fatal: "fatal",
				silent: void 0
			}[i];
			return c && typeof n[c] == "function" && n[c](`Request completed in ${s}ms`, {
				method: e.method,
				path: e.path,
				duration: s,
				...a && r ? { response: r } : {}
			}), r;
		} catch (t) {
			let r = Date.now() - o;
			throw n.error(`Request failed after ${r}ms`, t, {
				method: e.method,
				path: e.path,
				duration: r
			}), t;
		}
	});
}
//#endregion
export { f as CRITICAL_LEVELS, t as ColorEnum, d as DEFAULT_DEDUPLICATION_CONFIG, v as DEFAULT_SANITIZATION_CONFIG, b as DEFAULT_VALUE_RULES, i as ErrorSerializer, _ as FormatterFactory, p as LogDeduplicator, n as LogLevelEnum, u as LoggerContextError, l as LoggerError, G as LoggerService, c as LoggerStyleEngine, y as SENSITIVE_KEY_PATTERNS, w as applySanitizationRules, D as compileRules, K as createLoggerMiddleware, O as createSanitizer, r as isValidLogLevel, x as sanitizeControlChars, k as sanitizeMessage, E as sanitizeValue, q as withLogging };
